module.exports = require('./helpers/bundle-url').getBundleURL('k1NDn') + "logo-dark.eefe0b7f.svg";